import { BUSINESS_INFO } from '../data/business';
import { Brand } from './SiteHeader';

export default function SiteFooter({ onNavigate }) {
  return (
    <footer id="company-info" className="mf-footer" aria-label="회사 정보">
      <div className="mf-container mf-footer-inner" data-reveal>
        <div>
          <Brand onNavigate={onNavigate} />
          <p>재고와 광고를 잇는 커머스 운영 시스템</p>
          <a className="mf-footer-services" href="/services" onClick={onNavigate}>우리의 서비스 <span aria-hidden="true">↗</span></a>
        </div>
        <div className="mf-footer-meta">
          <strong className="mf-footer-company">{BUSINESS_INFO.name}</strong>
          <dl className="mf-business-info" aria-label="사업자 정보">
            <div><dt>대표자</dt><dd>{BUSINESS_INFO.representative}</dd></div>
            <div><dt>사업자등록번호</dt><dd>{BUSINESS_INFO.registrationNumber}</dd></div>
            <div className="mf-business-address"><dt>사업장 주소</dt><dd>{BUSINESS_INFO.address}</dd></div>
          </dl>
          <span className="mf-footer-copyright">© {new Date().getFullYear()} MarketFit. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}
